module.exports = __webpack_public_path__ + "img/CD.a377cb82.png";